export default "__VITE_ASSET__5JO2pcVU__"